import { Group, Stack } from "@mantine/core"

import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { CustomFieldTreeBranch } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldTreeBranch"
import { VerticalDivider } from "~/pages/Brand/Products/Details/CustomFieldGraph/Divider.tsx"
import type { GetItemOperations } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"
import { getCustomFieldDefinitionsForItem } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.utils"

type Props = {
  readonly materials: readonly LibraryResponses.EnrichedMaterial[]
  readonly product: LibraryResponses.ProductDetails
  readonly productActivityIds: readonly string[]
  readonly getOperations: GetItemOperations
}

export const CustomFieldMaterialsColumn = ({
  materials,
  product,
  productActivityIds,
  getOperations,
}: Props) => {
  return (
    <Stack align="flex-start" justify="left">
      {materials.length > 1 && (
        <VerticalDivider itemCount={materials.length} />
      )}
      {materials.map((material) => (
        <Group key={material.id} gap={0} align="flex-start" wrap="nowrap">
          <CustomFieldTreeBranch
            customFieldsDefs={getCustomFieldDefinitionsForItem(
              product,
              material.item,
              productActivityIds
            )}
            item={material.item}
            operations={getOperations(material.item)}
          />
        </Group>
      ))}
    </Stack>
  )
}
